import {VersionVariants} from '@jobseeker/lotus/enums';
import type {JobSearchBarProps} from './type';

import V1 from './V1';
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V1;

const JobSearchBar = (props: JobSearchBarProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default JobSearchBar;
